const RISK_STYLES = {
  低风险: { color: '#28C76F', bgColor: '#EAF9F1', percent: 28 },
  中风险: { color: '#FF9F43', bgColor: '#FFF5EA', percent: 58 },
  高风险: { color: '#EA5455', bgColor: '#FCEEEF', percent: 88 },
  高水平: { color: '#28C76F', bgColor: '#EAF9F1', percent: 88 },
  中等偏高: { color: '#28C76F', bgColor: '#EAF9F1', percent: 72 },
  中等: { color: '#FF9F43', bgColor: '#FFF5EA', percent: 50 },
  中等偏低: { color: '#FF9F43', bgColor: '#FFF5EA', percent: 38 },
  低水平: { color: '#EA5455', bgColor: '#FCEEEF', percent: 22 }
};

const SCALE_TAG_KEYS = new Set(['情绪情感', '认知行为', '环境适应', '成就动机', '问卷有效性']);

function riskStyle(level) {
  return RISK_STYLES[level] || { color: '#606266', bgColor: '#F3F4F6', percent: 40 };
}

function parseScaleValue(value) {
  const raw = value == null ? '' : String(value).trim();
  const m = raw.match(/^([\d.]+)\s*分\s*·\s*(.+)$/);
  if (!m) {
    return { raw, isScale: false };
  }
  const tail = m[2];
  const highRisk = tail.includes('高危预警');
  const level = tail.replace(/（高危预警）/g, '').trim();
  const style = riskStyle(level);
  return {
    isScale: true,
    score: m[1],
    level,
    highRisk,
    color: style.color,
    bgColor: style.bgColor,
    percent: style.percent
  };
}

function parseFunctionalValue(value) {
  const raw = value == null ? '' : String(value).trim();
  if (raw === '—' || !raw) {
    return { raw: '—', kind: 'text' };
  }
  if (/^-?[\d.]+%$/.test(raw)) {
    return { raw, kind: 'percent', main: raw.replace('%', ''), unit: '%' };
  }
  const ms = raw.match(/^(-?[\d.]+)\s*ms$/i);
  if (ms) {
    return { raw, kind: 'ms', main: ms[1], unit: 'ms' };
  }
  return { raw, kind: 'text', main: raw };
}

function isMainDimension(label, blockName) {
  if (!label || !blockName) return false;
  return label === blockName || label === 'ADHD' || label === '睡眠' && blockName === '睡眠';
}

function buildScaleBlock(blockName, rows) {
  const parsedRows = rows.map((row) => ({
    label: row.label,
    parsed: parseScaleValue(row.value)
  }));
  const mainRow =
    parsedRows.find((r) => isMainDimension(r.label, blockName)) ||
    parsedRows.find((r) => r.parsed.isScale) ||
    null;
  const subRows = parsedRows.filter((r) => r !== mainRow);
  return {
    type: 'scale-block',
    name: blockName,
    main: mainRow,
    subs: subRows
  };
}

function buildEmotionCard(tagLabel, rows) {
  const dims = rows
    .map((row) => ({
      label: row.label,
      ...parseScaleValue(row.value)
    }))
    .filter((d) => d.isScale);
  return {
    type: 'emotion',
    tagLabel,
    dims
  };
}

function buildValidityCard(rows) {
  const map = {};
  rows.forEach((r) => {
    map[r.label] = r.value;
  });
  return {
    type: 'validity',
    tagLabel: '问卷有效性',
    lieErrors: map['测谎题错误数'],
    validity: map['结果有效性']
  };
}

function buildFunctionalCard(tagLabel, rows) {
  return {
    type: 'functional',
    tagLabel,
    metrics: rows.map((row) => ({
      label: row.label,
      ...parseFunctionalValue(row.value)
    }))
  };
}

/**
 * 将后端 metrics 转为小程序报告式卡片结构
 */
export function buildAssessmentResultCards(metrics) {
  const list = Array.isArray(metrics) ? metrics : [];
  if (!list.length) return [];

  const tagMap = {};
  list.forEach((row) => {
    const section = row.section || '测评结果';
    const parts = section.split(' · ');
    const tag = parts[0];
    const block = parts[1] || '';
    if (!tagMap[tag]) {
      tagMap[tag] = { tagLabel: tag, rows: [], blocks: {} };
    }
    if (block) {
      if (!tagMap[tag].blocks[block]) tagMap[tag].blocks[block] = [];
      tagMap[tag].blocks[block].push(row);
    } else {
      tagMap[tag].rows.push(row);
    }
  });

  const cards = [];
  Object.keys(tagMap).forEach((tag) => {
    const group = tagMap[tag];
    if (tag === '问卷有效性') {
      cards.push(buildValidityCard(group.rows));
      return;
    }
    if (tag === '情绪情感') {
      cards.push(buildEmotionCard(tag, group.rows));
      return;
    }
    if (SCALE_TAG_KEYS.has(tag) && Object.keys(group.blocks).length) {
      const blocks = Object.keys(group.blocks).map((name) => buildScaleBlock(name, group.blocks[name]));
      cards.push({ type: 'scale-card', tagLabel: tag, blocks });
      return;
    }
    if (tag === '成就动机') {
      cards.push({
        type: 'achievement',
        tagLabel: tag,
        items: group.rows.map((row) => {
          const p = parseScaleValue(row.value);
          if (p.isScale) return { label: row.label, ...p };
          const raw = row.value;
          const levelMatch = String(raw).match(/·\s*(.+)$/);
          return {
            label: row.label,
            isScale: true,
            score: String(raw).split('·')[0].replace('分', '').trim(),
            level: levelMatch ? levelMatch[1].trim() : raw,
            ...riskStyle(levelMatch ? levelMatch[1].trim() : '')
          };
        })
      });
      return;
    }
    const allRows = group.rows.concat(
      Object.keys(group.blocks).reduce((acc, k) => acc.concat(group.blocks[k]), [])
    );
    if (allRows.length) {
      cards.push(buildFunctionalCard(tag, allRows));
    }
  });
  return cards;
}
